import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import Activity from "../components/Activity";
import defaultData from "../activityConfig.json";

import { Amplify } from "aws-amplify";
import { generateClient } from "aws-amplify/api";
import gql from "graphql-tag";

import config from "../aws-exports";

import "../pages/Dashboard.css";
const Dashboard = ({ handleAuthentication }) => {
  const navigate = useNavigate();
  const [activities, setActivities] = useState([]);
  const [activitiesdd, setActivitiesdd] = useState(defaultData);
  const [selectedActivity, setSelectedActivity] = useState(null); // For the selected activity
  const [selectedActivityDD, setSelectedActivityDD] = useState(null); // For the selected activity
  const [testTools, setTestTools] = useState(false);
  const handleLogout = () => {
    handleAuthentication(false); // This will clear the session and update the state
    navigate("/"); // Navigate back to the login page
  };
  Amplify.configure(config);

  const client = generateClient();

  const onCreateSubscription = gql`
    subscription OnCreateBackendActivityTable {
      onCreateBackendActivityTable {
        BackendActivityTableKey
        ActivityId
      }
    }
  `;

  useEffect(() => {
    if (defaultData.length > 0) {
      // Create a new array with an isSelected key
      const activitiesWithSelection = defaultData.map((activity, index) => ({
        ...activity,
        isSelected: index === 0,
        id: index + 1,
      }));

      // subscription();
      setSelectedActivityDD(activitiesWithSelection[0].activityId);
      setActivitiesdd(activitiesWithSelection);
    }
  }, []); // Empty dependency array ensures this runs once when the component mounts
  useEffect(() => {
    const subscription = client
      .graphql({
        query: onCreateSubscription,
      })
      .subscribe({
        next: (res) => {
          const tempact = activitiesdd.find(
            (x) =>
              x.activityId === res.data.onCreateBackendActivityTable.ActivityId
          );
          const activitiesWithSelection = activities.map((activity) => ({
            ...activity,
            isSelected: activity.isSelected,
          }));
          if (tempact) {
            activitiesWithSelection.forEach((x) => {
              x.isSelected = false;
            });
            tempact.isSelected = true;
            activitiesWithSelection.unshift(tempact);

            setActivities(
              activitiesWithSelection.map((activity, index) => ({
                ...activity,
                isSelected: activity.isSelected,
                id: index + 1,
              }))
            );
            setSelectedActivity(
              activitiesWithSelection.find((x) => x.isSelected === true)
            ); // Set the first activity as selected
          }
        },
        error: (error) => console.warn(error),
      });
    return () => subscription.unsubscribe();
  });
  const setSelectedActivityItem = (itemid) => {
    const activitiesWithSelection = activities.map((activity) => ({
      ...activity,
      isSelected: itemid === activity.id, // Set isSelected to true for the first entry
    }));
    setActivities(activitiesWithSelection); // Set the activities in state
    setSelectedActivity(activitiesWithSelection.find((x) => x.id === itemid)); // Set the first activity as selected
  };

  const AddItemToList = () => {
    const tempact = activitiesdd.find(
      (x) => x.activityId === selectedActivityDD
    );

    const activitiesWithSelection = activities.map((activity) => ({
      ...activity,
      isSelected: activity.isSelected,
    }));
    if (tempact) {
      activitiesWithSelection.forEach((x) => {
        x.isSelected = false;
      });
      tempact.isSelected = true;
      activitiesWithSelection.unshift(tempact);

      setActivities(
        activitiesWithSelection.map((activity, index) => ({
          ...activity,
          isSelected: activity.isSelected,
          id: index + 1,
        }))
      );
      setSelectedActivity(
        activitiesWithSelection.find((x) => x.isSelected === true)
      ); // Set the first activity as selected
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0]; // Get the uploaded file
    if (file && file.type === "application/json") {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          setActivities([]);
          setSelectedActivity(null);
          setActivitiesdd([]);

          const jsonData = JSON.parse(e.target.result); // Parse the uploaded file content
          if (jsonData.length > 0) {
            // Create a new array with an isSelected key
            const activitiesWithSelection = jsonData.map((activity, index) => ({
              ...activity,
              isSelected: index === 0,
              id: index + 1, // Set isSelected to true for the first entry
            }));
            //setActivities(activitiesWithSelection); // Set the activities in state
            setActivitiesdd(activitiesWithSelection);

            // setSelectedActivity(activitiesWithSelection[0]); // Set the first activity as selected
          } else {
            alert("Uploaded Json is invalid or empty!");
          }
        } catch (err) {
          alert("Invalid JSON file");
        }
      };
      reader.readAsText(file);
    } else {
      alert("Please upload a valid JSON file.");
    }
  };

  const AddTestTrigger = (e) => {
    e.preventDefault();
    setTestTools(!testTools);
  };
  return (
    <>
      <header className="header">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <a
              className="navbar-brand"
              href="#"
              onClick={(e) => AddTestTrigger(e)}
            >
              <div className="flex-data">
                <span>Convego Trusafe App</span>
                <div className="vertical-line"></div>
                <img
                  alt="Powered By Esignus"
                  src="https://cdn.esignus.com/WLA-activity-demo/img/logo_esignus.svg"
                />
              </div>
            </a>

            <div className="header-wrap">
              {activitiesdd && activitiesdd.length > 0 && testTools ? (
                <>
                  <select
                    id="dynamic-dropdown"
                    className="form-select"
                    value={selectedActivityDD}
                    onChange={(e) =>
                      setSelectedActivityDD(Number(e.target.value))
                    }
                  >
                    {[
                      ...new Map(
                        activitiesdd.map((item) => [item.activityId, item])
                      ).values(),
                    ].map((option) => (
                      <option value={option.activityId} key={option.activityId}>
                        {option.activityName}
                      </option>
                    ))}
                  </select>
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={AddItemToList}
                  >
                    Submit
                  </button>
                </>
              ) : (
                <></>
              )}

              {testTools ? (
                <input
                  type="file"
                  className="form-control header-upload ms-3"
                  id="upload-json"
                  accept="application/json"
                  onChange={handleFileUpload}
                />
              ) : (
                <></>
              )}
            </div>
            {/* <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
             
            </div> */}
            {/* Push this logout icon to the right */}
            <a className="logout ms-auto" onClick={() => handleLogout()}>
              <img
                src="https://cdn.esignus.com/WLA-activity-demo/img/icon_exit.svg"
                alt="Logout"
              />
            </a>
          </nav>
        </div>
      </header>

      <main>
        <div className="container">
          <div className="main-wrapper">
            <div className="sidebar">
              <p className="title mb-2">Registered activity</p>
              <p className="primaryText">SessionId:9874649h93</p>
              {/* Madhu add scrollbar */}
              <ul className="activityData">
                {activities && activities.length > 0 ? (
                  activities.map((activity) => (
                    <li
                      onClick={() => setSelectedActivityItem(activity.id)}
                      className={activity.isSelected === true ? "active" : ""}
                    >
                      {activity.activityName}
                    </li>
                  ))
                ) : (
                  // Array.from({ length: 100 }).map(() => (
                  //     <li>Test Activity</li>
                  //   ))
                  <></>
                )}
              </ul>
            </div>
            <div className="main-content">
              <div className="wrapper h-100">
                {selectedActivity ? (
                  <Activity
                    key={selectedActivity.activityId}
                    activity={selectedActivity}
                  />
                ) : (
                  //Madhu edit placeholders
                  <div className="col-12 h-100">
                    <div className="row h-100">
                      {Array.from({ length: 6 }).map(() => (
                        <div className="col-lg-4 col-sm-6 col-12 item">
                          <div className={`card`}></div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Dashboard;
